'use strict';

import { Component, EventEmitter, Output } from "@angular/core";
import { ferry } from '../../../services/ferry/ferry';
import { validEmail } from "../../../services/constants/emailRegex";

const userRegistrationHtml = <string>require('text!./userRegistrationComponent.html');

export type NewUserBasicInfo = {
    fullName: string; email: string;
    password: string;
    [key: string]: string;
};

@Component({
    selector: 'user-registration',
    template: userRegistrationHtml,
})

export class UserRegistrationComponent {
    @Output() back: EventEmitter<void> = new EventEmitter<void>();
    @Output() next: EventEmitter<NewUserBasicInfo> = new EventEmitter<NewUserBasicInfo>();
    @Output() close: EventEmitter<void> = new EventEmitter<void>();
    user: NewUserBasicInfo;
    errorMessage: string;

    constructor() {
        this.user = {
            fullName: '',
            email: '',
            password: ''
        };
    }

    updateUserInfo($event: Event, key: string) {
        this.user[key] = (<HTMLTextAreaElement>$event.target).value;
    }

    register(userData: NewUserBasicInfo) {
        ferry.sessionless_perform('account.test_user_email', [this.user.email]).then(() => {
            this.next.emit(userData);
        }).catch((err) => this.handleError(err));
    }

    allInputsValid(user: NewUserBasicInfo) {
        return (user.fullName &&
                validEmail(user.email) &&
                user.password);
    }

    handleError(err: {message: string}) {
        if (err.message.indexOf("Email address already taken") !== -1) {
            this.errorMessage = "This email address is already registered.";
        } else {
            this.errorMessage = "Something went wrong. Please check your information and try again.";
        }
    }

    clearError() {
        this.errorMessage = undefined;
    }
}



// WEBPACK FOOTER //
// ./_src/ui/preLoginApp/userRegistration/userRegistrationComponent.ts